enum InstitutionSortEnum {
  Institution = 1,
  Municipality = 2,
  County = 3,
  FounderType = 4,
}

export default InstitutionSortEnum;
